import React from 'react';
import { MessageCircle } from 'lucide-react';

export default function ConversationsEmptyState({
  conversationsCount,
}: {
  conversationsCount: number;
}) {
  return (
    <div className="flex-1 flex items-center justify-center bg-gray-50">
      <div className="mx-6 max-w-md rounded-2xl border border-dashed border-gray-300 bg-white p-8 text-center shadow-sm">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-teal-50 text-teal-600">
          <MessageCircle size={26} />
        </div>
        <h3 className="text-base font-semibold text-gray-800">
          {conversationsCount === 0 ? 'Sem conversas por aqui' : 'Selecione uma conversa'}
        </h3>
        <p className="mt-2 text-sm text-gray-500">
          {conversationsCount === 0
            ? 'Quando surgir uma nova conversa, ela vai aparecer na lista ao lado.'
            : 'Escolha uma conversa na lista para ver as mensagens e responder.'}
        </p>
      </div>
    </div>
  );
}
